<ami-dialog-message [setting]="message"></ami-dialog-message>
<pg-active-ingredient-create
  *ngIf="open.create"
  (close)="onCloseCreate()"
></pg-active-ingredient-create>

<pg-active-ingredient-update
  *ngIf="open.update"
  (close)="onCloseUpdate()"
  [row]="itemToUpdate"
></pg-active-ingredient-update>

<ami-table
  [settings]="table.settings"
  [data]="table.data"
  (action)="onReciveAction($event)"
></ami-table>
